import { useState } from 'react';

const provinces = [
  { name: '北京', label: '寻人服务', href: 'https://beijing.ngcac.com/' },
  { name: '天津', label: '寻人服务', href: 'https://tianjin.ngcac.com/' },
  { name: '河北', label: '寻人服务', href: 'https://hebei.ngcac.com/' },
  { name: '山西', label: '寻人服务', href: 'https://shanxi.ngcac.com/' },
  { name: '内蒙古', label: '寻人服务', href: 'https://neimeng.ngcac.com/' },
  { name: '辽宁', label: '寻人服务', href: 'https://liaoning.ngcac.com/' },
  { name: '吉林', label: '寻人服务', href: 'https://jilin.ngcac.com/' },
  { name: '黑龙江', label: '寻人服务', href: 'https://heilong.ngcac.com/' },
  { name: '上海', label: '寻人服务', href: 'https://shanghai.ngcac.com/' },
  { name: '江苏', label: '寻人服务', href: 'https://jiangsu.ngcac.com/' },
  { name: '浙江', label: '寻人服务', href: 'https://zhejiang.ngcac.com/' },
  { name: '安徽', label: '寻人服务', href: 'https://anhui.ngcac.com/' },
  { name: '福建', label: '寻人服务', href: 'https://fujian.ngcac.com/' },
  { name: '江西', label: '寻人服务', href: 'https://jiangxi.ngcac.com/' },
  { name: '山东', label: '寻人服务', href: 'https://shandong.ngcac.com/' },
  { name: '河南', label: '寻人服务', href: 'https://henan.ngcac.com/' },
  { name: '湖北', label: '寻人服务', href: 'https://hubei.ngcac.com/' },
  { name: '湖南', label: '寻人服务', href: 'https://hunan.ngcac.com/' },
  { name: '广东', label: '寻人服务', href: 'https://guangdong.ngcac.com/' },
  { name: '广西', label: '寻人服务', href: 'https://guangxi.ngcac.com/' },
  { name: '海南', label: '寻人服务', href: 'https://hainan.ngcac.com/' },
  { name: '重庆', label: '寻人服务', href: 'https://chongqing.ngcac.com/' },
  { name: '四川', label: '寻人服务', href: 'https://sichuan.ngcac.com/' },
  { name: '贵州', label: '寻人服务', href: 'https://guizhou.ngcac.com/' },
  { name: '云南', label: '寻人服务', href: 'https://yunnan.ngcac.com/' },
  { name: '西藏', label: '寻人服务', href: 'https://xizang.ngcac.com/' },
  { name: '陕西', label: '寻人服务', href: 'https://shaanxi.ngcac.com/' },
  { name: '甘肃', label: '寻人服务', href: 'https://gansu.ngcac.com/' },
  { name: '青海', label: '寻人服务', href: 'https://qinghai.ngcac.com/' },
  { name: '宁夏', label: '寻人服务', href: 'https://ningxia.ngcac.com/' },
  { name: '新疆', label: '寻人服务', href: 'https://xinjiang.ngcac.com/' },
  { name: '台湾', label: '寻人服务', href: 'https://taiwan.ngcac.com/' },
  { name: '香港', label: '寻人服务', href: 'https://xianggang.ngcac.com/' },
  { name: '澳门', label: '寻人服务', href: 'https://aomen.ngcac.com/' },
  { name: '海外', label: '寻人服务', href: 'https://haiwai.ngcac.com/' },
];

const SHOW_COUNT = 18;

const ProvincesSection = () => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? provinces : provinces.slice(0, SHOW_COUNT);

  return (
    <section id="provinces" className="py-16 bg-[#0f1a14]">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-8 gap-2">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <span className="w-1 h-5 bg-[#c9a84c] rounded-full inline-block"></span>
              <span className="text-xs font-semibold text-[#c9a84c] tracking-widest uppercase">Coverage Network</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white">全国侦探调查网络</h2>
            <p className="text-white/40 text-sm mt-1">覆盖全国各省市及港澳台、海外的专业私家侦探服务</p>
          </div>
          <div className="flex items-center gap-1 text-white/40 text-xs whitespace-nowrap">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-2-line text-[#c9a84c]"></i>
            </span>
            共 {provinces.length} 个服务区域
          </div>
        </div>

        {/* Province Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
          {visible.map((p) => (
            <a
              key={p.name}
              href={p.href}
              rel="nofollow"
              target="_blank"
              className="group relative flex flex-col items-center justify-center gap-0.5 bg-[#162218] border border-[#c9a84c]/10 rounded-xl py-3 px-1 cursor-pointer transition-all duration-200 hover:border-[#c9a84c]/50 hover:bg-[#1e2e1e] active:scale-95"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-[#c9a84c]/10 group-hover:bg-[#c9a84c]/20 transition-colors mb-1">
                <i className="ri-map-pin-line text-[#c9a84c]/60 group-hover:text-[#c9a84c] text-sm transition-colors"></i>
              </span>
              <span className="text-sm font-semibold text-white/80 group-hover:text-[#c9a84c] transition-colors leading-tight text-center">
                {p.name}
              </span>
              <span className="text-xs text-white/30 group-hover:text-[#c9a84c]/70 transition-colors leading-tight">
                {p.label}
              </span>
            </a>
          ))}
        </div>

        {/* Expand / Collapse */}
        {provinces.length > SHOW_COUNT && (
          <div className="flex justify-center mt-6">
            <button
              onClick={() => setExpanded(!expanded)}
              className="flex items-center gap-2 px-6 py-2 rounded-full border border-[#c9a84c]/20 bg-[#162218] text-sm text-white/50 hover:border-[#c9a84c]/60 hover:text-[#c9a84c] transition-all cursor-pointer whitespace-nowrap"
            >
              {expanded ? (
                <><i className="ri-arrow-up-s-line"></i>收起</>
              ) : (
                <><i className="ri-arrow-down-s-line"></i>展开全部 {provinces.length} 个区域</>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProvincesSection;
